    <template>
    <v-container class="toggle animated" fluid>
        <v-row dense>
            <v-col cols="12">
                <v-tabs v-model="selectedTab" align-tabs="start" color="darkGreen" @update:modelValue="initUsers()">
                    <v-tab :class="{'font-weight-black': selectedTab == institute.id}" v-for="institute in instituteData" :key="institute.id" :value="institute.id">
                        {{ institute.abbrev }}
                    </v-tab>
                </v-tabs>
            </v-col>
            <v-col cols="12" md="4">
                <v-text-field
                    v-model="search"
                    variant="outlined"
                    prepend-inner-icon="mdi-magnify"
                    label="Search"
                    density="comfortable"
                    solo
                    hide-details
                    rounded="lg"
                    color="primary"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
                <v-select
                    v-model="statusFilter"
                    :items="statusOptions"
                    label="Filter by Status"
                    variant="outlined"
                    dense
                    hide-details
                    density="comfortable"
                    solo
                    rounded="lg"
                    color="primary"
                ></v-select>
            </v-col>
            <v-col cols="12" md="3">
                <v-select
                    v-model="programFilter"
                    :items="programOptions"
                    label="Filter by Program/Department"
                    variant="outlined"
                    dense
                    hide-details
                    density="comfortable"
                    solo
                    rounded="lg"
                    color="primary"
                ></v-select>
            </v-col>
            <v-col v-if="data.length != 0" class="d-flex flex-column" cols="12" md="3">
                <v-btn
                @click="printWorkloadSummary(selectedTab, $store.state.semester_schoolyear.id)"
                prepend-icon="mdi-printer"
                class="mt-1 rounded-lg"
                color="green"
                height="40px"
                elevation="2">
                    Print Summary
                </v-btn>
            </v-col>
            <v-col v-if="data.length != 0" class="d-flex flex-column" cols="12" md="3">
                <v-btn
                @click="printWorkloadSummaryWithDetails(selectedTab, $store.state.semester_schoolyear.id)"
                prepend-icon="mdi-printer"
                class="mt-1 rounded-lg"
                color="green"
                height="40px"
                elevation="2">
                    Print Summary + Details
                </v-btn>
            </v-col>
            <!-- <v-col v-if="data.length != 0" class="d-flex flex-column" cols="12" md="3">
                <v-btn
                @click="showPrintAllApprovedDialog()"
                prepend-icon="mdi-printer"
                class="mt-1 rounded-lg"
                color="blue"
                height="40px"
                elevation="2">
                    Print All Approved
                </v-btn>
            </v-col> -->
            <v-col cols="12">
                <v-row dense>
                    <v-col cols="12" md="2">
                        <v-card elevation="4">
                            <v-card-title>
                                For Preparation
                            </v-card-title>
                            <v-card-text class="text-h4">
                                {{ statusCounts['For Preparation'] || 0 }}
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-card elevation="4">
                            <v-card-title>
                                For Recommending Approval
                            </v-card-title>
                            <v-card-text class="text-h4">
                                {{ statusCounts['For Recommending Approval'] || 0 }}
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-card elevation="4">
                            <v-card-title>
                                For Pre-Approval
                            </v-card-title>
                            <v-card-text class="text-h4">
                                {{ statusCounts['For Pre-approval'] || 0 }}
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-card elevation="4">
                            <v-card-title>
                                For Approval
                            </v-card-title>
                            <v-card-text class="text-h4">
                                {{ statusCounts['For Approval'] || 0 }}
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-card elevation="4">
                            <v-card-title>
                                Approved
                            </v-card-title>
                            <v-card-text class="text-h4">
                                {{ statusCounts['Approved'] || 0 }}
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12">
                <v-row dense>
                    <v-col cols="12">
                        <v-card class="dt-container mt-2">    
                            <v-data-table
                                :mobile="isMobileOrTablet()"
                                :headers="headers"
                                :items="filteredData"
                                :search="search"
                                :loading="loading"
                                :items-per-page="15"
                                :items-per-page-options="[15,30, 50, 100, -1]"
                            >
                            <template v-slot:loading>
                                <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                            </template>
                            <template v-slot:item.datecreated="{ item }">
                                <span>{{ formatDateTime(item.datecreated)}} </span>
                            </template>
                            <template v-slot:item.status="{ item }">
                                <v-chip :color="getWorkloadStatusColor(item)" class="text-caption">
                                    <span>{{ getWorkloadStatus(item) }}</span>
                                </v-chip>
                            </template>
                            <template v-slot:item.is_approved_to_print="{ item }">
                                <v-chip v-if="item.is_approved_to_print" color="green" size="small"><v-icon color="green">mdi-check</v-icon></v-chip>
                                <v-icon v-if="item.is_approved_to_print == false" color="red">mdi-close</v-icon>
                            </template>
                            <template v-slot:item.is_approved_printed="{ item }">
                                <v-chip v-if="item.is_approved_printed" color="green" size="small"><v-icon color="green">mdi-check</v-icon></v-chip>
                                <v-icon v-if="item.is_approved_printed == false" color="red">mdi-close</v-icon>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                                <div class="d-flex justify-end ga-2">
                                    <v-btn @click="showViewDialog(item)" size="small" variant="outlined" text="View" color="green" elevation="3"></v-btn>
                                </div>
                            </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>

    <CIDStaffWorkloadDialog ref="CIDStaffWorkloadDialog" @refresh="initUsers()"/>
    <PrintAllApprovedDialog ref="PrintAllApprovedDialog"/>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue';
import CIDStaffWorkloadDialog from '../Dialogs/CIDStaffWorkloadDialog.vue';
import PrintAllApprovedDialog from '../Dialogs/PrintAllApprovedDialog.vue';
import { generateFacultyWorkloadSummaryPDF } from '@/composables/pdf/faculty-workload-summary';
import { generateFacultyWorkloadSummaryWithDetailsPDF } from '@/composables/pdf/faculty-workload-summary-enhance';

export default defineComponent({
    components: {
        CIDStaffWorkloadDialog,
        PrintAllApprovedDialog
    },
    data(){
        return {
            data: [],
            search: null,
            loading: false,
            statusFilter: 'All',
            programFilter: 'All',
            headers: [
                { title: 'Faculty Name', align: 'start', sortable: true, key: 'faculty_name' },
                { title: 'Program/Department', align: 'start', sortable: true, key: 'user.program.abbrev' },
                { title: 'Dated Created', align: 'start', sortable: true, key: 'datecreated' },
                { title: 'Is Ready for Printing', align: 'start', sortable: true, key: 'is_approved_to_print' },
                { title: 'Is Printed', align: 'start', sortable: true, key: 'is_approved_printed' },
                { title: 'Status', align: 'start', sortable: true, key: 'status' },
                { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],

            instituteData: [],
            selectedTab: 0,
        }
    },
    computed: {
        filteredData() {
            let filtered = this.data;
            if (this.statusFilter && this.statusFilter !== 'All') {
                filtered = filtered.filter(item => this.getWorkloadStatus(item) === this.statusFilter);
            }
            if (this.programFilter && this.programFilter !== 'All') {
                filtered = filtered.filter(item => item.user?.program?.abbrev === this.programFilter);
            }
            return filtered.slice().sort((a, b) => {
                const statusA = this.getWorkloadStatus(a);
                const statusB = this.getWorkloadStatus(b);
                if (statusA === "For Pre-approval" && statusB !== "For Pre-approval") return -1;
                if (statusA !== "For Pre-approval" && statusB === "For Pre-approval") return 1;
                return 0;
            });
        },
        statusOptions() {
            const statuses = this.data.map(item => this.getWorkloadStatus(item));
            const uniqueStatuses = [...new Set(statuses)];
            return ['All', ...uniqueStatuses];
        },
        programOptions() {
            const programs = this.data.map(item => item.user?.program?.abbrev || 'Unknown Program');
            const uniquePrograms = [...new Set(programs)];
            return ['All', ...uniquePrograms];
        },
        statusCounts() {
            return this.data.reduce((acc, item) => {
                const status = this.getWorkloadStatus(item);
                acc[status] = (acc[status] || 0) + 1;
                return acc;
            }, {});
        }
    },
    methods: {
        async init(){
            await axios.get(process.env.VUE_APP_SERVER_URL + '/offices/getAllInstituteAndExternalCampus')
            .then(res => {
                this.instituteData = res.data
                this.selectedTab = this.instituteData[0].id
            });

            this.initUsers()
        },
        async initUsers(){
            this.loading = true
            let res = await this.axiosCall('/faculty-workload/findAllRecommendedAprrovalByInstituteAndSemesterSchoolyear/' + this.selectedTab + '/' + this.$store.state.semester_schoolyear.id, 'get', null, true)
            if(res && res.data){
                this.loading = false
                this.data = res.data
            }
        },
        getWorkloadStatus(item) {
            if (!item.prepared_status) return "For Preparation";
            if (item.prepared_status === "prepared" && !item.recommending_approval_status) return "For Recommending Approval";
            if (item.recommending_approval_status === "recommended" && !item.pre_approved_status) return "For Pre-approval";
            if (item.pre_approved_status === "pre-approved" && !item.approved_status) return "For Approval";
            if (item.approved_status === "approved") return "Approved";
            return "Unknown Status";
        },
        getWorkloadStatusColor(item) {
            if (!item.prepared_status) return "orange";
            if (item.prepared_status === "prepared" && !item.recommending_approval_status) return "blue";
            if (item.recommending_approval_status === "recommended" && !item.pre_approved_status) return "teal-darken-4";
            if (item.pre_approved_status === "pre-approved" && !item.approved_status) return "purple";
            if (item.approved_status === "approved") return "green";
            return "gray";
        },
        async printWorkloadSummary(instituteId, semesterSchoolyearId){
            let res = await this.axiosCall('/faculty-workload/summaryOfFacultyWorkload/' + instituteId + '/' + semesterSchoolyearId, 'get', null, true)
            if (res.data){
                generateFacultyWorkloadSummaryPDF(res.data, {
                    semester: this.$store.state.semester_schoolyear.semester,
                    schoolYear: this.$store.state.semester_schoolyear.schoolyear,
                    instituteName: this.instituteData.find(inst => inst.id === instituteId)?.name || '',
                    preparedBy: this.$store.state.user
                });
            }
        },
        async printWorkloadSummaryWithDetails(instituteId, semesterSchoolyearId){
            let res = await this.axiosCall('/faculty-workload/summaryOfFacultyWorkloadWithDetails/' + instituteId + '/' + semesterSchoolyearId, 'get', null, true)
            if (res.data){
                generateFacultyWorkloadSummaryWithDetailsPDF(res.data, {
                    semester: this.$store.state.semester_schoolyear.semester,
                    schoolYear: this.$store.state.semester_schoolyear.schoolyear,
                    instituteName: this.instituteData.find(inst => inst.id === instituteId)?.name || '',
                    preparedBy: this.$store.state.user
                });
            }
        },
        showViewDialog(data){
            this.$refs.CIDStaffWorkloadDialog.initView(data)
        },
        showPrintAllApprovedDialog(){
            const approvedData = this.data.filter(item => item.approved_status === 'approved')
            this.$refs.PrintAllApprovedDialog.init(
                this.$store.state.semester_schoolyear.id,
                approvedData,
                this.programOptions
            )
        },
    },
    mounted(){
        this.init()
    }
})
</script>

<style scoped>

</style>